import { z } from 'zod';
import { UUIDSchema } from '../ids.js';
export const AmenityReservationStatusSchema = z.enum([
    'booked',
    'cancelled',
    'no_show',
    'completed',
]);
export const AmenityReservationSchema = z.object({
    id: UUIDSchema,
    tenant_id: UUIDSchema,
    amenity_id: UUIDSchema,
    reserved_by_user_id: UUIDSchema,
    starts_at: z.string(),
    ends_at: z.string(),
    status: AmenityReservationStatusSchema,
    notes: z.string().nullable(),
    cancelled_at: z.string().nullable(),
    cancelled_by_user_id: UUIDSchema.nullable(),
    cancelled_reason: z.string().nullable(),
    created_at: z.string(),
    updated_at: z.string(),
});
const MAX_LOOKAHEAD_MS = 90 * 24 * 60 * 60 * 1000; // 90 days
const MAX_DURATION_MS = 24 * 60 * 60 * 1000; // 24 hours
export const CreateAmenityReservationBody = z
    .object({
    starts_at: z.string().datetime(),
    ends_at: z.string().datetime(),
    notes: z.string().trim().max(500).optional(),
})
    .refine((b) => new Date(b.ends_at) > new Date(b.starts_at), {
    message: 'ends_at must be after starts_at',
    path: ['ends_at'],
})
    .refine((b) => new Date(b.ends_at).getTime() - new Date(b.starts_at).getTime() <= MAX_DURATION_MS, {
    message: 'reservation cannot exceed 24 hours',
    path: ['ends_at'],
})
    .refine((b) => new Date(b.starts_at).getTime() - Date.now() <= MAX_LOOKAHEAD_MS, {
    message: 'reservations cannot be booked more than 90 days ahead',
    path: ['starts_at'],
});
export const CancelAmenityReservationBody = z.object({
    reason: z.string().trim().max(500).optional(),
});
//# sourceMappingURL=amenity-reservation.js.map